import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { toastr } from 'react-redux-toastr';
import { Prompt } from 'react-router';

import * as createApplicationActions from '../../../redux/actions/CreateApplicationActions';
import * as suggestionsActions from '../../../redux/actions/SuggestionsActions';
import { getBlankChecks } from '../../../redux/actions/FundsActions';
import { getSystemSettings, getTags } from '../../../redux/actions/SettingsActions';
import { getRecipientAccountDetails, getOrganizations } from '../../../redux/actions/RecipientAccountsActions';

import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import CreateRecipient from './CreateRecipient';
import CreateApplication from './CreateApplication';
import PrintInfo from './PrintInfo';
import PaymentInfo from './PaymentInfo';
import CheckExistsWarningModal from './CheckExistsWarningModal';
import IncompleteApplicationWarning from '../../commonComponents/shared/IncompleteApplicationWarning';
import CreateCancelButtons from './CreateCancelButtons';
import WarningModal from '../../commonComponents/shared/WarningModal';
import LoadingSpinner from '../../commonComponents/util/LoadingSpinner';
import MarkInquiry from '../applicationsCommon/MarkInquiry';

import { PayeeTypes, SourceTypes, PhoneNumberTypes } from '../../../lib/constants';
import { Departments, PermissionTypes, RecipientTypes } from '../../../lib/systemVariables';
import { concatenateAddressLabel, deepEquals, getApplicationPayee, getIndividualDisplayName, getOrgDisplayName, isEmptyObj } from '../../../lib/utils';

class CreateApplicationPage extends NavigationComponent {
    constructor(props) {
        super(props);

        let isIsraeli = this.props.userProfile.departments.length === 1 && this.props.userProfile.departments.indexOf(Departments.IL) > -1;

        this.state = {
            showModals: {
                warning: false,
                checkExistsWarningModal: false,
            },
            navigationOnSubmission: false,
            submitAttempted: false,
            error: false,
            teudatZehutError: false,
            manualCheckError: false,
            manualCheckLabel: '',
            dataErrors: {
                email: false,
                phoneNumber: false,
                secondPhoneNumber: false,
            },
            showEmail: false,
            showSecondPhone: false,
            showPrevAddress: false,
            showCareOf: false,
            setTrustedPayee: false,
            applicationSourceType: SourceTypes.New,
            thirdPartyPayeeType: SourceTypes.New,
            noSuggestions: false,

            recipient: {
                id: 0,
                applicantType: !props.permissions.individuals ? RecipientTypes.Organization : RecipientTypes.Individual,
                isIsraeli: isIsraeli,
                displayName: '',
                addressDisplay: '',
                title: '',
                firstName: '',
                lastName: '',
                reportName: '',
                organization: {
                    institutionTitleId: null,
                    name: '',
                    registered: true,
                    taxId: ''
                },
                address: {},
                previousAddress: {},
                teudatZehut: '',
                phoneNumber: '',
                phoneType: PhoneNumberTypes.American,
                secondPhoneNumber: '',
                secondPhoneType: PhoneNumberTypes.American,
                email: '',
                bankRoutingNumber: '',
                bankBranchNumber: '',
                bankAccountNumber: '',
                bankAccountHolder: '',
                achRoutingNumber: '',
                achAccountNumber: '',
                achAccountType: '',
                bankAccounts: [],
                tags: [],
                note: '',
                references: [],
                solicitors: [],
                roshYeshivas: [],
                applicantPledges: [],
                trustedPayee: null,
            },
            application: {
                attachments: [],
                paymentInfo: {
                    manualPayment: {
                        blankCheckId: null,
                        manualPaymentType: null,
                        manualPaymentNumber: null,
                        manualPaymentDate: null,
                        manualPaymentAmount: null
                    },
                    fundId: (isIsraeli ? this.props.utils.defaultIsraelFund : this.props.utils.defaultUSFund) || '',
                    payTo: PayeeTypes.Recipient,
                    thirdParty: {
                        referenceId: '',
                        useRecipientAddress: false,
                        isIsraeli: isIsraeli,
                        firstName: '',
                        lastName: '',
                        orgName: '',
                        address: {},
                        bankNumber: '',
                        branchNumber: '',
                        accountNumber: '',
                        accountHolder: '',
                        careOf: ''
                    },
                    checkMemo: '',
                    reportMemo: '',
                },
                isPrivate: false,
                reasonId: '',
                reasonDate: '',
                weddingHall: '',
                weddingSide: '',
                requestAmount: '',
                approverId: this.props.userProfile.defaultApproverId || '',
                individualCategoryId: '',
                sourceId: '',
                note: '',
                cardTypeId: '',
                printInstructions: '',
                inquire: false,
                inquireNote: '',
                applicantPledgeId: ''
            }
        };

        this.state.initialApplication = this.state.application;
        this.state.initialRecipient = this.state.recipient;
    }

    componentWillMount() {
        if (this.props.match.params.recipientId)
            this.setRecipientDetails(this.props.match.params.recipientId);
    }

    componentWillUnmount() {
        if (this.props.recipientSuggestions.data.length)
            this.props.actions.clearRecipientSuggestions();
    }

    setRecipientDetails = async recipientId => {
        await this.props.actions.getRecipientAccountDetails(recipientId);

        if (!this.props.recipientDetails.success) {
            toastr.error('Something went wrong', 'We were unable to retrieve recipient information. Please try again.');
        } else {
            const { initialRecipient } = this.state;
            const recipientDetails = this.props.recipientDetails.data;

            const prevRecipient = this.state.recipient;
            this.setState({
                recipient: {
                    ...initialRecipient,
                    id: recipientDetails.applicantId,
                    applicantType: recipientDetails.applicantType,
                    isIsraeli: recipientDetails.isIsraeli,
                    displayName: recipientDetails.displayName,
                    reportName: recipientDetails.reportName,
                    addressDisplay: recipientDetails.addressDisplay,
                    address: recipientDetails.address,
                    phoneNumber: recipientDetails.phoneNumber,
                    secondPhoneNumber: recipientDetails.secondPhoneNumber,
                    incomplete: recipientDetails.incomplete,
                    references: recipientDetails.references,
                    solicitors: recipientDetails.solicitors,
                    roshYeshivas: recipientDetails.roshYeshivas,
                    trustedPayee: recipientDetails.trustedPayee,
                    bankAccounts: recipientDetails.bankAccounts,
                    applicantPledges: recipientDetails.applicantPledges,
                }
            }, () => this.onUpdateRecipient(this.state.recipient, prevRecipient));
        }
    }

    onChange = (name, value) => {
        if (name === "recipient") {
            this.updateRecipient(value);
        } else {
            this.setState({ [name]: value });
        }
    }

    updateRecipient = recipient => {
        const prevRecipient = this.state.recipient;
        this.setState({ recipient }, this.onUpdateRecipient(recipient, prevRecipient));
    }

    onUpdateRecipient = (recipient, prevRecipient) => {
        let applicationUpdate = { ...this.state.application };

        if (recipient.isIsraeli !== prevRecipient.isIsraeli) {
            applicationUpdate = this.onUpdateRecipientIsIsraeli(applicationUpdate, recipient.isIsraeli);
        }
        if (recipient.type !== prevRecipient.type) {
            applicationUpdate = this.onUpdateRecipientType(applicationUpdate);
        }
        if (!recipient.address.street && prevRecipient.address.street) {
            applicationUpdate = this.onClearRecipientAddress(applicationUpdate);
        }
        if (recipient.trustedPayee ? recipient.trustedPayee.referenceId : null
            != prevRecipient.trustedPayee ? prevRecipient.trustedPayee.referenceId : null) {
            applicationUpdate = this.onUpdateRecipientTrustedPayee(applicationUpdate, recipient.trustedPayee);
        }
        if (recipient.references.length < prevRecipient.references.length) {
            const removedReferenceIds = prevRecipient.references.map(r => r.referenceId.toString()).filter(refId => recipient.references.map(r => r.referenceId.toString()).indexOf(refId.toString) < 0);
            applicationUpdate = this.onRemoveRecipientReferences(applicationUpdate, removedReferenceIds, recipient.references.length);
        }

        this.setState({ application: applicationUpdate });
    }

    onUpdateRecipientIsIsraeli(application, isIsraeli) {
        const hasThirdParty = application.paymentInfo.payTo === PayeeTypes.ThirdParty
            && (application.paymentInfo.thirdParty.referenceId || application.paymentInfo.thirdParty.orgName || application.paymentInfo.thirdParty.lastName);

        let fundId = application.paymentInfo.fundId;
        if ((!application.paymentInfo.manualPayment || !application.paymentInfo.manualPayment.manualPaymentType) && application.paymentInfo.payTo !== PayeeTypes.TrustedPayee && !hasThirdParty) {
            fundId = isIsraeli ? this.props.utils.defaultIsraelFund : this.props.utils.defaultUSFund; //don't reset fundId if manual check, pay to trusted payee, or has third party
        }

        application = isIsraeli
            ? {
                ...application,
                printInstructions: '',
                cardTypeId: '',
                paymentInfo:
                {
                    ...application.paymentInfo,
                    checkMemo: '',
                    reportMemo: '',
                    fundId
                }
            }
            : {
                ...application,
                paymentInfo: {
                    ...application.paymentInfo,
                    fundId
                }
            };

        if (!hasThirdParty) //if no third party, default third party isIsraeli to recipient isIsraeli
            application.paymentInfo.thirdParty = { ...application.paymentInfo.thirdParty, isIsraeli };

        return application;
    }

    onUpdateRecipientType(application) {
        return { ...application, reasonId: null };
    }

    onClearRecipientAddress(application) {
        if (application.paymentInfo.thirdParty.useRecipientAddress) {
            this.onChange('showCareOf', false);

            application.paymentInfo.thirdParty = {
                ...application.paymentInfo.thirdParty,
                useRecipientAddress: false,
                careOf: ''
            };
        }
        return application;
    }

    onUpdateRecipientTrustedPayee(application, trustedPayee) {
        const { recipient, initialApplication } = this.state;

        const hasThirdParty = application.paymentInfo.payTo === PayeeTypes.ThirdParty
            && (application.paymentInfo.thirdParty.referenceId || application.paymentInfo.thirdParty.orgName || application.paymentInfo.thirdParty.lastName);

        if (!trustedPayee && application.paymentInfo.payTo === PayeeTypes.TrustedPayee) { //cleared out trusted payee, and payTo is set to trustedPayee
            application.paymentInfo = {
                ...application.paymentInfo,
                payTo: PayeeTypes.Recipient,
                ...recipient.isIsraeli !== (recipient.trustedPayee || {}).isIsraeli ?
                    { fundId: recipient.isIsraeli ? this.props.utils.defaultIsraelFund : this.props.utils.defaultUSFund } : {}
            };
        } else if (trustedPayee && !hasThirdParty) { //set trusted payee, and no third party info filled in
            const prevPayee = getApplicationPayee(application.paymentInfo, recipient);
            application.paymentInfo = {
                ...application.paymentInfo,
                payTo: PayeeTypes.TrustedPayee,
                thirdParty: { ...initialApplication.paymentInfo.thirdParty, isIsraeli: recipient.isIsraeli },
                ...trustedPayee.isIsraeli !== prevPayee.isIsraeli ?
                    { fundId: trustedPayee.isIsraeli ? this.props.utils.defaultIsraelFund : this.props.utils.defaultUSFund } : {}
            };
        }

        return application;
    }

    onRemoveRecipientReferences(application, removedReferenceIds, referencesCount) {
        const { recipient, initialApplication, applicationSourceType, thirdPartyPayeeType } = this.state;

        if (applicationSourceType === SourceTypes.Reference) {
            if (!referencesCount)
                this.onChange('applicationSourceType', SourceTypes.New);

            if (removedReferenceIds.indexOf(application.sourceId.toString()) >= 0)
                application.sourceId = null;
        }

        if (application.paymentInfo.payTo === PayeeTypes.ThirdParty && thirdPartyPayeeType === SourceTypes.Reference) {
            if (!referencesCount)
                this.onChange('thirdPartyPayeeType', SourceTypes.New);

            if (removedReferenceIds.indexOf(application.paymentInfo.thirdParty.referenceId.toString()) >= 0) {
                application.paymentInfo = {
                    ...application.paymentInfo,
                    ...recipient.isIsraeli !== application.paymentInfo.thirdParty.isIsraeli //reset fund to default for recipient nationality if isIsraeli of prev reference does not match recipient
                        ? { fundId: recipient.isIsraeli ? this.props.utils.defaultIsraelFund : this.props.utils.defaultUSFund } : {},
                    thirdParty: { //clear out thirdparty specifics, reset isIsraeli
                        ...initialApplication.paymentInfo.thirdParty,
                        isIsraeli: recipient.isIsraeli
                    }
                };
                this.onChange('showCareOf', false);
            }
        }

        return application;
    }

    updateApplication = (name, val) => {
        let application = { ...this.state.application, [name]: val };
        this.setState({ application });
    }

    updatePaymentInfo = (name, val) => {
        const { application } = this.state;

        if (name === 'fundId' && application.paymentInfo.manualPayment.manualPaymentType) {
            this.props.actions.getBlankChecks(val);
            this.setState({
                manualCheckLabel: '',
                application: {
                    ...application,
                    paymentInfo: {
                        ...application.paymentInfo,
                        [name]: val,
                        manualPayment: {
                            ...application.paymentInfo.manualPayment,
                            blankCheckId: ''
                        }
                    }
                }
            });
        } else {
            this.setState({
                application: {
                    ...application,
                    paymentInfo: {
                        ...application.paymentInfo,
                        [name]: val
                    }
                }
            });
        }
    }

    updateDataErrors = (name, val) => {
        this.setState({ dataErrors: { ...this.state.dataErrors, [name]: val } });
    }

    save = async (bypass = false) => {
        if (this.state.error || this.state.manualCheckError || this.state.teudatZehutError) {
            this.setState({ error: false, manualCheckError: false, teudatZehutError: false }); //hide errors while submit
        }

        if (this.state.submitAttempted || !this.getIncompleteFields()) {
            const recipient = {
                ...this.state.recipient,
                references: this.state.recipient.references.map(ref => ({ referenceId: ref.referenceId, relationship: ref.relationship })),
                solicitors: this.state.recipient.solicitors.map(ref => ({ referenceId: ref.referenceId, relationship: ref.relationship })),
                roshYeshivas: this.state.recipient.roshYeshivas.map(ref => ({ referenceId: ref.referenceId, relationship: ref.relationship })),
                trustedPayeeId: this.state.recipient.trustedPayee ? this.state.recipient.trustedPayee.referenceId : null
            };
            const application = this.state.application;

            if(!application.paymentInfo.manualPayment || !application.paymentInfo.manualPayment.manualPaymentType) {
                application.paymentInfo.manualPayment = null;
            }

            await this.props.actions.createApplication(recipient, application, bypass);

            if (this.props.createApplication.success) {
                if (!this.state.recipient.id) { //created a new recipient
                    if (this.state.recipient.applicantType === RecipientTypes.Organization) {
                        this.props.actions.getOrganizations(); //get updated organization tags
                    }

                    if ((this.state.recipient.address.country && this.props.utils.nationalities.indexOf(this.state.recipient.address.country) < 0)
                        || (this.state.recipient.address.city && this.props.utils.cities.indexOf(this.state.recipient.address.city) < 0)) {
                        this.props.actions.getSystemSettings(); //get updated nationalities/cities
                    }
                }

                this.setState({ navigationOnSubmission: true }, () => this.pushRoute('/applications?applyFilters=true'));

            } else {
                if (this.props.createApplication.id && !this.state.recipient.id) { //recipient was created, create application failed
                    this.setState({
                        recipient: {
                            ...this.state.recipient,
                            id: this.props.createApplication.id,
                            displayName: (this.state.recipient.organization && this.state.recipient.organization.name)
                                ? getOrgDisplayName(this.state.recipient.organization.institutionTitleId, this.state.recipient.organization.name, this.state.recipient.isIsraeli)
                                : getIndividualDisplayName(this.state.recipient.personTitleId, this.state.recipient.firstName, this.state.recipient.lastName, this.state.recipient.isIsraeli),
                            addressDisplay: concatenateAddressLabel(this.state.recipient.address)
                        }
                    });
                }

                if (this.props.createApplication.message) {
                    if (this.props.createApplication.message.toLowerCase().indexOf("60 days") >= 0) {
                        this.toggleModal("warning");
                    } else if (this.props.createApplication.message.toLowerCase().indexOf('check number assigned') >= 0) {
                        this.toggleModal("checkExistsWarningModal");
                    } else if (this.props.createApplication.message.toLowerCase().indexOf("available") >= 0) {
                        this.setState({
                            manualCheckError: true,
                            manualCheckLabel: '',
                            application: {
                                ...this.state.application,
                                paymentInfo: {
                                    ...this.state.application.paymentInfo,
                                    manualPayment: {
                                        blankCheckId: null,
                                        manualPaymentType: null,
                                        manualPaymentNumber: null,
                                        manualPaymentDate: null,
                                        manualPaymentAmount: null
                                    }
                                }
                            }
                        });
                    } else if (this.props.createApplication.message.toLowerCase().indexOf('teudat') >= 0) {
                        this.setState({ teudatZehutError: true });
                    }
                } else {
                    this.setState({ error: true });
                }
            }
        } else {
            if (!this.state.submitAttempted) this.setState({ submitAttempted: true });
        }
    }

    getRequiredFields = () => {
        const { recipient, application } = this.state;
        const requiredFields = [];

        if (application.paymentInfo.manualPayment && application.paymentInfo.manualPayment.manualPaymentType && !recipient.id) {
            if (recipient.applicantType === RecipientTypes.Individual) {
                if (!recipient.lastName) requiredFields.push('Last Name');
            } else {
                if (!recipient.organization.name) requiredFields.push('Organization Name');
            }
        }
        else {
            if (!application.approverId) requiredFields.push("Approver");
            if (!application.paymentInfo.fundId) requiredFields.push("Fund");
            if (this.state.setTrustedPayee && !recipient.trustedPayee) requiredFields.push("Trusted Payee");
            if (!recipient.id) {
                if (recipient.applicantType === RecipientTypes.Individual
                    && !recipient.firstName && !recipient.lastName
                    && !recipient.phoneNumber && !recipient.secondPhoneNumber && isEmptyObj(recipient.address))
                    requiredFields.push("one or more of the following: First Name, Last Name, Phone number, Address");
                else if (recipient.applicantType === RecipientTypes.Organization
                    && !recipient.organization.name && !recipient.phoneNumber && !recipient.secondPhoneNumber && isEmptyObj(recipient.address))
                    requiredFields.push("one or more of the following: Organization name, Phone number, Address");
            }
        }

        return requiredFields;
    }

    getIncompleteFields = () => {
        const incompleteFields = { recipientInfo: [], applicationInfo: [], paymentInfo: [] };
        const { application, recipient } = this.state;

        //if manual payment only require manual payment fields and last name
        if (application.paymentInfo.manualPayment && application.paymentInfo.manualPayment.manualPaymentType) {
            if (!application.paymentInfo.manualPayment.manualPaymentAmount || !application.paymentInfo.manualPayment.manualPaymentDate || !application.paymentInfo.manualPayment.manualPaymentNumber) {
                incompleteFields.paymentInfo.push('Incomplete Manual Payment Information');
            }

            if (!recipient.id) {
                if (recipient.applicantType === RecipientTypes.Individual) {
                    if (!recipient.lastName) incompleteFields.recipientInfo.push('Last Name');
                } else {
                    if (!recipient.organization.name) incompleteFields.recipientInfo.push('Name');
                }
            }
        }
        else {
            //recipient info
            if (!recipient.id) {
                if (recipient.isIsraeli) {
                    if (recipient.applicantType === RecipientTypes.Individual) {
                        if (!recipient.teudatZehut) incompleteFields.recipientInfo.push('Teudat Zehut');
                    }

                    if (!recipient.trustedPayee) {
                        if (!recipient.bankRoutingNumber) incompleteFields.recipientInfo.push('Bank Number');
                        if (!recipient.bankBranchNumber) incompleteFields.recipientInfo.push('Branch Number');
                        if (!recipient.bankAccountNumber) incompleteFields.recipientInfo.push('Account Number');
                    }
                }
                if (recipient.applicantType === RecipientTypes.Individual) {
                    if (!recipient.firstName) incompleteFields.recipientInfo.push('First Name');
                    if (!recipient.lastName) incompleteFields.recipientInfo.push('Last Name');
                } else {
                    if (!recipient.organization.name) incompleteFields.recipientInfo.push('Name');
                    if (recipient.organization.registered && !recipient.organization.taxId) incompleteFields.recipientInfo.push('Tax ID');
                }
                if (!recipient.tags.length) incompleteFields.recipientInfo.push('Categories');
                if (!recipient.address.streetNumber || !recipient.address.street || !recipient.address.city || !recipient.address.country)
                    incompleteFields.recipientInfo.push('Address is Incomplete');
            }

            // application info:
            if (!application.reasonId) incompleteFields.applicationInfo.push('Reason');
            if (!application.approverId) incompleteFields.applicationInfo.push('Approver');

            //paymentInfo:
            if (!application.paymentInfo.fundId) incompleteFields.paymentInfo.push('Fund');
            
            const thirdParty = application.paymentInfo.thirdParty;
            if (application.paymentInfo.payTo === PayeeTypes.ThirdParty) {
                if (this.state.thirdPartyPayeeType === SourceTypes.Reference) {
                    if (!thirdParty.referenceId)
                        incompleteFields.paymentInfo.push('Third Party Payee');
                } else {
                    if (!thirdParty.orgName && (!thirdParty.firstName || !thirdParty.lastName)) incompleteFields.paymentInfo.push('Third Party Payee Name');
                    if (thirdParty.isIsraeli
                        && (!thirdParty.bankNumber || !thirdParty.branchNumber || !thirdParty.accountNumber))
                        incompleteFields.paymentInfo.push('Third Party Payee Bank Information');
                    else if (!thirdParty.isIsraeli  && !thirdParty.useRecipientAddress
                        && (!thirdParty.address.streetNumber || !thirdParty.address.street || !thirdParty.address.city || !thirdParty.address.country))
                        incompleteFields.paymentInfo.push('Third Party Payee Address');
                }
            }
        }

        if (!incompleteFields.applicationInfo.length && !incompleteFields.paymentInfo.length && incompleteFields.recipientInfo.length) { //only recipient is incomplete
            const missingOnlyRecipientPaymentInfo = incompleteFields.recipientInfo.every(field => field === 'Bank Number' || field === 'Branch Number' || field === 'Account Number'); //missing only pymt info
            const notUsingRecipientPaymentInfo = (application.paymentInfo.payTo !== PayeeTypes.Recipient || (application.paymentInfo.manualPayment && application.paymentInfo.manualPayment.manualPaymentType)); //AND not pay to recipient, or manual check pymt (so don't need recipient pymt info)

            incompleteFields.incompleteApplicationDueToRecipient = !missingOnlyRecipientPaymentInfo || !notUsingRecipientPaymentInfo;
        }

        return (incompleteFields.recipientInfo.length || incompleteFields.applicationInfo.length || incompleteFields.paymentInfo.length) ? incompleteFields : null;
    }

    render() {
        const { application, recipient, dataErrors, submitAttempted, initialApplication, initialRecipient, applicationSourceType, thirdPartyPayeeType, showCareOf } = this.state;
        const { tags, utils } = this.props;

        const payee = getApplicationPayee(application.paymentInfo, recipient);
        const formIsDirty = !deepEquals(application, initialApplication) || !deepEquals(recipient, initialRecipient);
        const isApprover = this.props.permissions.applications.approve;
        const isAdmin = this.props.permissions.admin;

        const requiredFields = this.getRequiredFields();
        const requiredFieldsMessage = formIsDirty && requiredFields.length
            ? `Please complete the following required field${requiredFields.length > 1 ? "s" : ""}: ${requiredFields.join(', ')}.` : '';

        const incompleteFields = this.getIncompleteFields(this.state.recipient);

        const errorMessage = this.state.manualCheckError ? 'The selected manual check number is not available.  Please select a different check number.'
            : this.state.recipient.id ? 'Something went wrong and the application could not be created.  Please try again.'
                : this.state.teudatZehutError ? 'The specified teudat zehut is already in use.  Please enter a unique teudat zehut.'
                    : 'Something went wrong and the recipient and application could not be created.  Please try again.';

        return (
            <div className="application-create">
                <Prompt when={!this.state.navigationOnSubmission && formIsDirty}
                    message='All unsaved changes will be lost if you leave this page.  Are you sure you want to proceed?' />
                <div className="subheader">
                    <div className="container application-create-subheader">
                        <h2 className="page-header">Create Application</h2>
                        <div className="back-link">
                            <i className="icon ion-android-arrow-back middle medium-text" />
                            <Link to="/applications" className="link-text small-text">Back to Applications</Link>
                        </div>
                    </div>
                </div>
                <div className="container application-create-content">
                    {this.props.recipientDetails.loading && <div className="spinner-background"><LoadingSpinner height="32" /></div>}
                    <div className="application-create-top">
                        <CreateRecipient
                            tags={{
                                usPersonTitles: utils.usPersonTitles,
                                israelPersonTitles: utils.israelPersonTitles,
                                usInstitutionTitles: utils.usInstitutionTitles,
                                israelInstitutionTitles: utils.israelInstitutionTitles,
                                recipientTypes: !this.props.permissions.individuals
                                    ? utils.recipientTypes.filter(type => type.value === RecipientTypes.Individual)
                                    : !this.props.permissions.institutions
                                        ? utils.recipientTypes.filter(type => type.value === RecipientTypes.Organization)
                                        : utils.recipientTypes,
                                categories: {
                                    individualTags: utils.individualTags,
                                    organizationTags: utils.organizationTags
                                }
                            }}
                            departments={this.props.userProfile.departments}
                            submitAttempted={submitAttempted}
                            recipient={recipient}
                            isManualPayment={application.paymentInfo.manualPayment && application.paymentInfo.manualPayment.manualPaymentType}
                            dataErrors={dataErrors}
                            updateDataErrors={this.updateDataErrors}
                            toggleModal={this.toggleModal}

                            onChange={this.onChange}
                            onSelectRecipientSuggestion={this.setRecipientDetails}

                            suggestions={{
                                suggestions: this.props.recipientSuggestions.data,
                                getSuggestions: this.props.actions.getRecipientSuggestions,
                                clearSuggestions: this.props.actions.clearRecipientSuggestions
                            }}
                            showSecondPhone={this.state.showSecondPhone}
                            showEmail={this.state.showEmail}
                            showPrevAddress={this.state.showPrevAddress}
                            setTrustedPayee={this.state.setTrustedPayee}
                            allowIncomplete={true} />

                        <PaymentInfo
                            submitAttempted={submitAttempted}
                            paymentInfo={application.paymentInfo}
                            manageAccounting={this.props.permissions.accounting.manage}

                            payeeIsIsraeli={payee.isIsraeli}
                            initialThirdParty={{ ...initialApplication.paymentInfo.thirdParty, isIsraeli: recipient.isIsraeli }}
                            trustedPayee={recipient.trustedPayee}

                            onChange={this.onChange}
                            updateApplication={this.updateApplication}
                            updatePaymentInfo={this.updatePaymentInfo}

                            funds={(payee.isIsraeli && (!application.paymentInfo.manualPayment || !application.paymentInfo.manualPayment.manualPaymentType)) ? tags.israelFunds : tags.usFunds}
                            defaultUSFund={utils.defaultUSFund}
                            defaultIsraeliFund={utils.defaultIsraelFund}

                            blankChecks={this.props.blankChecks}
                            getBlankChecks={this.props.actions.getBlankChecks}
                            manualCheckLabel={this.state.manualCheckLabel}
                            manualPaymentTypes={utils.manualPaymentTypes}

                            thirdPartyPayeeType={thirdPartyPayeeType}
                            showCareOf={showCareOf}
                            recipientReferences={recipient.references.filter(ref => ref.isPayable)}
                            recipientAddress={(!recipient.isIsraeli && !dataErrors.recipientAddress && recipient.address.street) ? concatenateAddressLabel(recipient.address) : ''}
                            recipientTypes={utils.recipientTypes} />
                    </div>

                    <CreateApplication
                        permissions={this.props.permissions.applications}
                        tags={{
                            applicationReasons: recipient.applicantType === RecipientTypes.Organization ? utils.organizationApplicationReasons : utils.individualApplicationReasons,
                            approvers: tags.approvers,
                            references: tags.references,
                            campaignIndivCategories: utils.campaignIndivCategories
                        }}
                        payeeIsIsraeli={payee.isIsraeli}
                        submitAttempted={submitAttempted}
                        updateApplication={this.updateApplication}
                        application={application}
                        applicationSourceType={applicationSourceType}
                        toggleSourceType={(name, value) => {
                            this.onChange(name, value);
                            this.updateApplication("sourceId", '');
                        }}
                        recipientReferences={recipient.references}
                        recipientPledges={recipient.applicantPledges}
                        isManualPayment={application.paymentInfo.manualPayment && application.paymentInfo.manualPayment.manualPaymentType}
                        toggleModal={this.toggleModal} />

                    {!payee.isIsraeli &&
                        <PrintInfo cardTypes={utils.cardTypes}
                            selectedCardType={application.cardTypeId}
                            updateApplication={this.updateApplication}
                            printInstructions={application.printInstructions} />}

                    {(isApprover || isAdmin) && 
                        <MarkInquiry inquire={application.inquire}
                            inquireNote={application.inquireNote}
                            updateApplication={this.updateApplication}/>}
                    
                    {(submitAttempted && incompleteFields) &&
                        <IncompleteApplicationWarning
                            fields={incompleteFields}
                            allowIncomplete={true} />}

                    <CreateCancelButtons save={this.save}
                        disabled={Object.keys(this.state.dataErrors).some(k => this.state.dataErrors[k]).length > 0 || requiredFields.length > 0}
                        disabledMessage={requiredFields.length > 0 ? requiredFieldsMessage : ''}
                        loading={this.props.createApplication.loading}
                        show={this.state.error || this.state.manualCheckError || this.state.teudatZehutError}
                        message={errorMessage}
                        cancel={() => this.setState({ navigationOnSubmission: true }, () => this.pushRoute('/applications'))} />
                </div>

                <WarningModal
                    show={this.state.showModals.warning}
                    message='This recipient has received a check in the past 60 days.'
                    close={() => this.toggleModal("warning")}
                    continue={() => this.save(true)} />

                <CheckExistsWarningModal
                    transactions={this.props.createApplication.data}
                    message={this.props.createApplication.message}
                    show={this.state.showModals.checkExistsWarningModal}
                    close={() => this.toggleModal("checkExistsWarningModal")}
                    continue={() => this.save(true)} />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        recipientDetails: state.recipientAccountDetails.recipientDetails,
        createApplication: state.createApplication.createApplication,
        blankChecks: state.fundDetails.blankChecks,
        userProfile: {
            departments: state.userProfile.profile.data ? state.userProfile.profile.data.departments : [],
            defaultApproverId: state.userProfile.profile.data.defaultApproverId || '',
        },
        permissions: {
            applications: {
                manage: state.userProfile.permissions.data.indexOf(PermissionTypes.ApplicationsManage) >= 0,
                private: state.userProfile.permissions.data.indexOf(PermissionTypes.ApplicationsPrivate) >= 0,
                approve: state.userProfile.permissions.data.indexOf(PermissionTypes.ApproveFullApplications) >= 0 ||
                         state.userProfile.permissions.data.indexOf(PermissionTypes.ApplicationsApproveLimited) >= 0
            },
            accounting: {
                manage: state.userProfile.permissions.data.indexOf(PermissionTypes.AccountingManage) >= 0
            },
            individuals: state.userProfile.permissions.data.indexOf(PermissionTypes.IndividualsManage) >= 0,
            institutions: state.userProfile.permissions.data.indexOf(PermissionTypes.InstitutionsManage) >= 0,
            admin: state.userProfile.profile.data.roleId === 1
        },
        utils: {
            defaultUSFund: state.settings.systemSettings.data.fundSettings.defaultUSFund || '',
            defaultIsraelFund: state.settings.systemSettings.data.fundSettings.defaultIsraelFund || '',
            recipientTypes: state.settings.systemSettings.data.otherSettings.recipientTypes,
            individualTags: state.settings.systemSettings.data.recipientSettings.individualTags,
            organizationTags: state.settings.systemSettings.data.recipientSettings.organizationTags,
            nationalities: state.settings.systemSettings.data.otherSettings.nationalities,
            cities: state.settings.systemSettings.data.otherSettings.cities,
            cardTypes: state.settings.systemSettings.data.printSettings.cardTypes,
            individualApplicationReasons: state.settings.systemSettings.data.applicationSettings.individualApplicationReasons,
            organizationApplicationReasons: state.settings.systemSettings.data.applicationSettings.organizationApplicationReasons,
            usPersonTitles: state.settings.systemSettings.data.recipientSettings.usPersonTitles,
            israelPersonTitles: state.settings.systemSettings.data.recipientSettings.israelPersonTitles,
            usInstitutionTitles: state.settings.systemSettings.data.recipientSettings.usInstitutionTitles,
            israelInstitutionTitles: state.settings.systemSettings.data.recipientSettings.israelInstitutionTitles,
            campaignIndivCategories: state.settings.systemSettings.data.campaignSettings.campaignIndivCategories,
            manualPaymentTypes: state.settings.systemSettings.data.otherSettings.manualPaymentTypes,
        },
        tags: {
            campaigns: state.campaigns.campaigns.data,
            organizations: state.recipientAccounts.organizations.data,
            approvers: state.users.approvers.data,
            references: state.references.references.data,
            israelFunds: state.funds.fundsByDept.activeIL,
            usFunds: state.funds.fundsByDept.activeUS
        },
        ...state.suggestions
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...createApplicationActions,
            ...suggestionsActions,
            getRecipientAccountDetails,
            getTags,
            getSystemSettings,
            getOrganizations,
            getBlankChecks
        }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateApplicationPage);




// WEBPACK FOOTER //
// ./src/components/applicationsComponents/newApplication/CreateApplicationPage.jsx